import { IActionFn, IPageData } from '@/store/types';
import { IModuleState } from './types';
import { $asset, $http } from '@/axios';

// 查询已发布的导航
export const queryDpgNavTrees: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  const dpgName = payload ? `DesignProject_${payload}` : 'DesignProject';
  const fetchDpgPublished = $asset('oss', `data/navigation_${dpgName}.json`, { ignoreCodes: [404] });

  commit('setDpgNavTrees', { ...state.navTrees, loading: true });
  Promise.all([fetchDpgPublished]).then((results) => {
    const [dpgTrees = null] = results || [];

    // 这里表示 compTree 的根节点里没有 id 时, 则 id 值用 -1 填充; 有 id 时, 则使用请求结果里的 id
    const dpgRoot = dpgTrees ? { id: -2, entityType: 'DesignProject', ...dpgTrees, name: '专案' } : null;
    commit('setDpgNavTrees', { raw: [dpgRoot].filter((item) => !!item) });
  }).catch(() => {
    commit('setDpgNavTrees', { raw: [] });
  });
};

// 查询专案列表(图片列表)
export const queryDpgImgList: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    const { entity, ...rest } = payload;
    const postMap: Record<string, string> = {
      DesignProject: '/v1/data/design/dpg/search',
    };
    commit('setDpgImgList', { ...state.imgList, loading: true });
    const res: IPageData = await $http.post(postMap[entity], rest);
    commit('setDpgImgList', {
      data: res.list, pageNum: res.pageNum, pageSize: res.pageSize,
      total: res.total, params: payload,
    });
  } catch (e) {
    commit('setDpgImgList', { data: [], pageNum: 0, pageSize: 0, total: 0 });
  }
};
